module.exports = __webpack_public_path__ + "static/media/album.4d40b023.svg";